module.exports = __webpack_public_path__ + "static/media/flag-dutch.22452c3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-dutch.svg
// module id = 1126
// module chunks = 1